import { render, staticRenderFns } from "./PersistAlertaView.vue?vue&type=template&id=6a6ebb46&"
import script from "./PersistAlertaView.vue?vue&type=script&lang=ts&"
export * from "./PersistAlertaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports